/**
 * About Section Component
 * Company introduction and founder information
 */
import { BRAND_CONFIG } from '../../config/brand';
import polaroidBen from '../../ben-polaroid.webp';

const AboutSection = () => {
  return (
    <section
      id="about"
      className="animate-padding-top relative z-6 flex min-h-[600px] overflow-hidden bg-[#121110]/30 pb-15 shadow-[0_-25px_40px_rgba(200,70,_0,_0.10),0_0px_200px_rgba(150,_255,_0,_0.05)] before:absolute before:z-10 before:h-full before:max-h-full before:min-h-full before:w-screen before:max-w-full before:min-w-screen before:transform-[scale(1.1)] before:bg-gradient-to-b before:from-[#581d03] before:via-[#2f1a0a] before:to-[#121212] before:bg-cover before:bg-top-left before:bg-no-repeat before:opacity-100 before:!content-['']"
    >
      <div className="z-15 mx-auto flex h-full w-full max-w-[95vw] flex-col justify-center px-4 pt-15 md:max-w-[80vw]">
        <img
          src="./orange-brush.webp"
          alt=""
          className="absolute top-0 left-0 -z-10 h-full w-full object-cover opacity-35 select-none"
        />
        <h1 className="fira-sans-black text-center text-5xl font-bold text-shadow-[0_0px_10px_rgba(0,_0,_0,_0.5)] md:mb-10">
          Gloucester's home of collectors, players, and nerds{' '}
          {BRAND_CONFIG.emoji}
        </h1>
        <div className="mt-10 flex h-full max-h-[100%] flex-wrap gap-4 md:flex-nowrap">
          <div className="flex w-full flex-shrink-0 flex-col gap-2 md:w-3/4 md:pr-10">
            <p className="mt-8">
              <strong>Full Fire TCG</strong> is a trading card game store based
              in Gloucester, UK. We have a huge range of stock, covering{' '}
              <strong>Pokémon</strong>, <strong>Magic: The Gathering</strong>,{' '}
              <strong>One Piece</strong>, and <strong>Yu-Gi-Oh!</strong>.
              Whether you're a collector or a player, we have something for you!
            </p>
            <p className="mt-8">
              Located on the waterfront of the beautiful Gloucester Docks, we're
              within walking distance of transport, parking, and the city
              center.
            </p>
            <p className="mt-8">We'd love to see you in-store!</p>
            <p className="signature mt-8 !text-2xl">- Ben</p>
            <p className="-mt-2 !text-[0.95rem] text-zinc-400">
              Founder of Full Fire
            </p>
          </div>
          <div className="flex h-full w-full flex-shrink-0 flex-col gap-2 pt-10 md:w-1/4 md:pt-0">
            <img
              className="max-h-[300px] -rotate-1 object-contain md:rotate-3"
              src={polaroidBen}
              alt="Ben, founder of Full Fire TCG"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
